import { defineMessages } from 'react-intl';

export default defineMessages({
  category: 'Category',
  hint: 'The new parent directory must contain a path to a valid {category}',
  name: 'Board Name',
  path: 'Board ID Path'
});
